const updateModel = (model) => {
	(window.DisneyDataLayer || (window.DisneyDataLayer = [])).push(
		["reset"],
		["update", model]
	);
};

const trackLink = (model) => {
	const updatedModel = {
		...model,
		trackingType: "customLink",
	};
	(window.DisneyDataLayer || (window.DisneyDataLayer = [])).push([
		"trackElement",
		updatedModel,
	]);
};

const trackPage = (pageId, options) => {
	const { reportSuiteId, ...rest } = options;
	updateModel({
		configuration: {
			SiteCatalyst: {
				reportSuiteId,
			},
		},
		...rest,
		pageId,
	});
};

export { trackLink, updateModel, trackPage };
